import { useState } from 'react'
import { Answer, Question } from '../../Types'
import { AnswerSubmissionDetails } from './AnswerSubmissionDetails'
import { Collapse } from 'antd'
import { AnswerFactory } from './AnswerFactory'

type Props = { answers: Answer[]; question: Question; defaultLang: string }
export const AnswerHistory = ({ answers, question, defaultLang }: Props) => {
  const [open, setOpen] = useState<boolean>(false)
  if (answers.length === 0) {
    return null
  }

  const nested = answers
    .map((answer: Answer, index: number) => {
      return index === 0 ? null : (
        <div key={answer._id} className="px-0 py-1" style={{}}>
          <AnswerFactory
            answer={answer}
            question={question}
            defaultLang={defaultLang}
            variant="SECONDARY"
          ></AnswerFactory>
          <AnswerSubmissionDetails
            createdAt={answer.createdAt}
            deviceTime={answer.deviceTime}
            isOffline={!!answer.offline}
            index={index}
          ></AnswerSubmissionDetails>
        </div>
      )
    })
    // we dont render the first answer
    .filter((item) => item !== null)

  const items = [
    {
      key: 0,
      label: (
        <div className="py-1">
          <p className="ps-1 noselect" style={{ opacity: open ? 1 : 0.75 }}>
            Answer history {!open ? <span className="opacity-50">- Click to view</span> : null}
          </p>
        </div>
      ),
      children: (
        <div className="ps-2" style={{ marginTop: '-12px' }}>
          {nested}
        </div>
      ),
      styles: { body: { paddingTop: 10, paddingLeft: 8, paddingRight: 0 } },
    },
  ]

  //
  return (
    <div className="" style={{ fontSize: '0.8rem', marginBottom: 0 }}>
      {nested.length > 0 ? (
        <div className="mt-1" style={{ borderTop: `1px solid ${open ? '#ddd' : '#ccc'}` }}>
          <Collapse
            ghost
            accordion={false}
            rootClassName=""
            onChange={(key) => setOpen(Array.isArray(key) ? key.length > 0 : !!key)}
            expandIconPlacement={'end'}
            items={items}
            size="small"
            style={{ fontSize: '0.8rem', marginLeft: -8 }}
          />
        </div>
      ) : null}
    </div>
  )
}
